"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { haptic } from "@/lib/haptic";
import { Mark, type MarkName } from "./mark";
import styles from "./tab-bar.module.css";

const TABS: { href: string; label: string; mark: MarkName }[] = [
  { href: "/", label: "Map", mark: "map" },
  { href: "/feeling", label: "Feeling", mark: "sun" },
  { href: "/you", label: "You", mark: "pin" },
];

export function TabBar() {
  const path = usePathname();
  // The welcome and sign-in screens are their own thing and the bar would only be in the way.
  if (path === "/welcome" || path.startsWith("/signin")) return null;

  const index = TABS.findIndex((t) => (t.href === "/" ? path === "/" : path.startsWith(t.href)));

  return (
    <nav className={styles.bar} aria-label="Screens">
      <div className={styles.inner} style={{ "--active": index } as React.CSSProperties}>
        {index >= 0 && <span className={styles.pill} aria-hidden="true" />}
        {TABS.map((t) => {
          const active = t.href === "/" ? path === "/" : path.startsWith(t.href);
          return (
            <Link onClick={() => haptic.tap()}
              key={t.href}
              href={t.href}
              className={styles.tab}
              aria-current={active ? "page" : undefined}
            >
              <Mark name={t.mark} size={22} color="currentColor" decorative className={styles.mark} />
              <span>{t.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
